import { SearchOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import useDatasetStore from '../../../../store/datasetStore';
import useHomeStore from '../../../../store/homeStore';
import useSearchStore from '../../../../store/searchStore';

export function useSelectedDataset() {
  const setSearchId = useSearchStore((state) => state.setSearchId);
  const searchId = useSearchStore((state) => state.searchId);
  const selectDataset = useSearchStore((state) => state.selectedDataset);
  const setSelectDataset = useSearchStore((state) => state.setSelectedDataset);
  const setSelectedSearchId = useSearchStore(
    (state) => state.setSelectedSearchId
  );
  const selectedSearchId = useSearchStore((state) => state.selectedSearchId);

  const datasetBriefs = useDatasetStore((state) => state.datasetBriefs);

  const navigate = useNavigate();

  function onChange(id: string) {
    const selectItem = datasetBriefs.find((d) => d.id === id);
    if (!selectItem) return;

    setSearchId(id);
    setSelectDataset({ ...selectItem });
    setSelectedSearchId(id);
    navigate(`/metadata/${selectItem.id}`);
  }

  return {
    selectDataset,
    onChange,
    datasetBriefs,
    searchId,
    selectedSearchId,
  };
}

const SearchBar: FC = () => {
  const { onChange, datasetBriefs, selectedSearchId } = useSelectedDataset();

  const dropdownSearchbarOpen = useHomeStore(
    (state) => state.dropdownSearchbarOpen
  );
  const setDropdownSearchbarOpen = useHomeStore(
    (state) => state.setDropdownSearchbarOpen
  );

  return (
    <Select
      id='Header-Search_Input'
      data-testid='Header-Search_Input'
      open={dropdownSearchbarOpen}
      placeholder='Search Datasets…'
      onDropdownVisibleChange={setDropdownSearchbarOpen}
      showSearch
      value={selectedSearchId === '' ? undefined : selectedSearchId}
      style={{ width: '325px' }}
      optionFilterProp='children'
      onChange={onChange}
      suffixIcon={<SearchOutlined />}
      filterOption={(input, option: any) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {datasetBriefs.map((data, index) => {
        return (
          <Select.Option key={data.id} value={data.id}>
            {`${index + 1}, ${data.title}`}
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default SearchBar;
